// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2JZJj","head":"ProcedureTableInfo_head__29XR2"};